import '../../webpack-path';
import React, { type JSX } from 'react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { isUndefined } from 'lodash';
import { createRoot, type Container } from 'react-dom/client';
import { type BbkClientConfig } from '@bbkAdminRedux/rtkq/preauth-company.slice';

// Renders to current script Tag
const parentCurrentScriptTag = (): Container | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  const scriptTag = document.scripts[document.scripts.length - 1];
  if (isUndefined(scriptTag)) {
    return null;
  }
  return scriptTag.parentNode as Container | null;
};

type RenderClientFn<
  T extends JSX.IntrinsicAttributes = JSX.IntrinsicAttributes,
> = (
  ComponentToRender: React.ComponentType<T>,
  props: T,
  clientConfig?: BbkClientConfig
) => void;

export const renderInlineToDOM: RenderClientFn = (
  ComponentToRender,
  props,
  clientConfig
) => {
  // console.log('[RENDERING DOM]', arguments);
  window.bbkClientConfig = clientConfig;
  const container =
    document.querySelector('#FunnelApp') ?? parentCurrentScriptTag();
  createRoot(container!).render(<ComponentToRender {...props} />);
};
